import React from 'react';
import { LayoutContainerStyled } from './styles';

interface ILayoutContainer {
  children: React.ReactNode;
}

const LayoutContainer = ({ children }: ILayoutContainer): React.ReactElement => {
  return <LayoutContainerStyled>{children}</LayoutContainerStyled>;
};

export default LayoutContainer;
